/* eslint-disable react/prop-types */
import React from "react";
import LineItem from "./LineItem";
import "./merch-page.m.css";

const Cart = props => {
  const openCheckout = () => {
    if (/*props.subscription.userHasSubscription &&*/ lineItems.length) {
      window.open(props.checkout.webUrl);
    }
  };

  const lineItems = props.checkout.lineItems.map(lineItem => {
    return (
      <LineItem
        updateQuantityInCart={props.updateQuantityInCart}
        removeLineItemInCart={props.removeLineItemInCart}
        key={lineItem.id.toString()}
        line_item={lineItem}
      />
    );
  });

  return (
    <div styleName={`cart ${props.isCartOpen ? "cart--open" : ""}`}>
      <header styleName="cart__header">
        <h2 styleName="">Newslaundry Cart</h2>
        <button onClick={props.handleCartClose} styleName="cart__close">
          ×
        </button>
      </header>
      <ul styleName="cart__line-items">{lineItems}</ul>
      <footer styleName="cart__footer">
        <div>
          <div styleName="cart-info__total cart-info__small">Total (incl. Taxes)</div>
          <div styleName="cart-info__pricing">
            <span styleName="pricing">₹ {props.checkout.totalPrice}</span>
          </div>
        </div>
        <button
          styleName="cart__checkout"
          onClick={/*props.subscription.userHasSubscription ? openCheckout : props.dialog*/ openCheckout}
        >
          Checkout
        </button>
      </footer>
    </div>
  );
};

export default Cart;
